import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";

import { v4 as uuidv4 } from "uuid";

import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import CustomAlert from "../../Components/CustomAlert";
import { observer, Observer } from "mobx-react";
import { reaction } from "mobx";
import { useTranslation } from "react-i18next";
import { useScreenDimensions, useDevice } from "../../_layout";
import IconEmptyView from "../../Components/IconEmptyView";
import { ScrollView } from "react-native-web";

import { formatNumber } from "../../utils/numberUtils";

import { Menu, MenuItem } from "react-native-material-menu";
import { AntDesign, Ionicons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import { format } from "date-fns";

import { useDrag, useDrop } from "react-dnd";
import AddNutritionPlanView from "../../NutritionPlan/AddNutritionPlanView";
import SearchBar from "../../Components/SearchBar";
import CTAButton from "../../Components/CTAButton";

const ClientNutrition = ({ client }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [showingAddNutritionPlan, setShowingAddNutritionPlan] = useState(false);

  const [showingSplit, setShowingSplit] = useState(false);

  const [text, setText] = useState("");

  const PlanRow = observer(({ nutritionPlan }) => {
    const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
    const deleteAlertTitle = "deleteNutritionPlanAlertTitle-string";
    const deleteAlertText = "deleteNutritionPlanAlertText-string";

    const [competitionMenu, setCompetitionMenu] = useState(false);
    const showCompetitionMenu = () => setCompetitionMenu(true);

    const deletePlan = () => {
      client.updateClientDeletionNutritionPlans(nutritionPlan.id);
      client.startOrResetBatchTimer();

      client.setProperty(
        "nutritionPlans",
        (client.nutritionPlans = client.nutritionPlans.filter(
          (np) => np.id !== nutritionPlan.id
        ))
      );
    };

    const onClose = () => {
      setCompetitionMenu(false);
      setIsHovered(false);
    };

    const action = () => {
      client.initAuxNutritionPlan(nutritionPlan);
      setShowingAddNutritionPlan(true);
    };

    const showDeleteAlert = () => {
      setShowingDeleteAlert(true);
      setCompetitionMenu(false);
    };
    const showEditCompetition = () => {
      client.initAuxNutritionPlan(nutritionPlan);
      setShowingAddNutritionPlan(true);
      setCompetitionMenu(false);
    };

    const addToLibrary = () => {
      setCompetitionMenu(false);
      nutritionPlan.copyNutritionPlanToLibrary();
      setIsHovered(false);
    };

    const [isHovered, setIsHovered] = useState(false);

    const [isMenuHovered, setIsMenuHovered] = useState(false);

    const MenuItemView = ({ idx }) => {
      const [isHovered, setIsHovered] = useState(false);

      return idx === 0 ? (
        <MenuItem
          onPress={() => {
            const newNutritionPlan = nutritionPlan.client.copyNutritionPlan(
              t,
              nutritionPlan
            );
            nutritionPlan.client.updateClientTransactionNutritionPlans(
              newNutritionPlan.id
            );
            nutritionPlan.client.startOrResetBatchTimer();
            setIsHovered(false);
            setCompetitionMenu(false);
          }}
          style={{ minWidth: 190 }}
          textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("copyNutritionPlan-string")}
        </MenuItem>
      ) : idx === 1 ? (
        <MenuItem
          onPress={addToLibrary}
          style={{ minWidth: 190 }}
          textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("exportToLibrary-string")}
        </MenuItem>
      ) : (
        <MenuItem
          onPress={showDeleteAlert}
          style={{ minWidth: 150 }}
          textStyle={{
            fontSize: 14,
            color: "red",
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("delete-string")}
        </MenuItem>
      );
    };

    return (
      <View style={{ width: "100%" }}>
        <TouchableOpacity
          onPress={action}
          style={{
            backgroundColor: "white",
            borderRadius: 14,
            borderWidth: 0.1,
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: screenSize === "small" ? 12 : 15,
            paddingBottom: screenSize === "small" ? 12 : 15,
            paddingHorizontal: screenSize === "small" ? 12 : 15,
            marginBottom: screenSize === "small" ? 8 : 12,
            borderColor: isHovered ? "rgba(0, 0, 0, 0.5)" : Colors.borderColor,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              height: screenSize !== "small" && 65,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                flexShrink: 1,
              }}
            >
              <Text
                numberOfLines={2}
                style={[
                  screenSize === "small" ? Fonts.medium14 : Fonts.medium16,
                  { width: "100%", marginBottom: 10, flexShrink: 1 },
                ]}
              >
                {nutritionPlan.name}
              </Text>
              <View
                style={[
                  GlobalStyles.HStack,
                  { width: "100%", flexWrap: "wrap" },
                ]}
              >
                <View style={[GlobalStyles.HStack]}>
                  <FontAwesome5
                    name="clipboard-list"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {t("numberOfMeals-string", {
                      number: nutritionPlan.meals.length,
                    })}
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <FontAwesome5
                    name="bullseye"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {nutritionPlan.caloriesGoal > 0
                      ? `${formatNumber(
                          nutritionPlan.getMacroTotal("calories")
                        )} / ${nutritionPlan.caloriesGoal}`
                      : `${formatNumber(
                          nutritionPlan.getMacroTotal("calories")
                        )}`}{" "}
                    kcal
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <View
                    style={[
                      GlobalStyles.rowIcon,
                      {
                        width: 12,
                        height: 12,
                        borderRadius: 50,
                        backgroundColor: Colors.carbsColor,
                      },
                    ]}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {formatNumber(nutritionPlan.getMacroTotal("carbs"))}
                    {"g "}
                    carbohidratos
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <View
                    style={[
                      GlobalStyles.rowIcon,
                      {
                        width: 12,
                        height: 12,
                        borderRadius: 50,
                        backgroundColor: Colors.proteinColor,
                      },
                    ]}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {formatNumber(nutritionPlan.getMacroTotal("protein"))}
                    {"g "}
                    proteína
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <View
                    style={[
                      GlobalStyles.rowIcon,
                      {
                        width: 12,
                        height: 12,
                        borderRadius: 50,
                        backgroundColor: Colors.fatsColor,
                      },
                    ]}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {formatNumber(nutritionPlan.getMacroTotal("fats"))}
                    {"g "}
                    grasas
                  </Text>
                </View>
              </View>
            </View>

            <Menu
              visible={competitionMenu}
              anchor={
                <TouchableOpacity
                  onPress={showCompetitionMenu}
                  onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                  onMouseLeave={() => setIsMenuHovered(false)}
                >
                  <Entypo
                    name="dots-three-horizontal"
                    size={screenSize === "small" ? 22 : 24}
                    color="black"
                    style={{
                      paddingVertical: screenSize === "small" ? 8 : 16,
                      paddingHorizontal: screenSize === "small" ? 0 : 16,
                      opacity: isMenuHovered ? 0.5 : 1,
                      marginLeft: screenSize === "small" ? 8 : 0,
                    }}
                  />
                </TouchableOpacity>
              }
              style={GlobalStyles.menu}
              onRequestClose={() => setCompetitionMenu(false)}
            >
              <MenuItemView idx={0} />
              <MenuItemView idx={1} />
              <MenuItemView idx={2} />
            </Menu>
          </View>
        </TouchableOpacity>

        {showingDeleteAlert && (
          <CustomAlert
            isVisible={showingDeleteAlert}
            onClose={() => setShowingDeleteAlert(false)}
            title={deleteAlertTitle}
            text={deleteAlertText}
            action={deletePlan}
            specialCTA={"delete-string"}
          />
        )}
      </View>
    );
  });

  const SplitView = () => {
    const PlanButton = ({ isInWeekDay, plan }) => {
      const [{ isDragging }, drag] = useDrag({
        type: "SLOT_EXERCISE",
        item: { plan }, // Pass the `slotExercise` data
        canDrag: () => false,
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
      });

      return (
        <View
          ref={drag}
          style={{
            width: isInWeekDay && "calc(100% - 16px)",
            padding: isInWeekDay ? 8 : 8,
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: Colors.bubbleColor,
            opacity: isDragging ? 0.5 : 1,
          }}
        >
          <Text style={{ fontSize: 11, textAlign: "center", color: "white" }}>
            {/* {slotExercise.slotExerciseSlotTextFor(t)} */}
            {t(plan.name)}
          </Text>
        </View>
      );
    };

    const WeekDay = observer(({ weekDay }) => {
      const Header = () => {
        return (
          <View
            style={{
              width: "calc(100% - 16px)",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 12,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
            >
              {t(weekDay)}
            </Text>
            <View
              style={{
                height: 1,
                backgroundColor: Colors.borderColor,
                width: "100%",
                marginTop: 5,
              }}
            />
          </View>
        );
      };

      const [{ isOver, canDrop }, drop] = useDrop({
        accept: "SLOT_EXERCISE",
        drop: (item) => handleDrop(item.slotExercise),
        collect: (monitor) => ({
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        }),
      });

      const handleDrop = (slotExercise) => {
        const weekdaysMap = {
          monday: 1,
          tuesday: 2,
          wednesday: 3,
          thursday: 4,
          friday: 5,
          saturday: 6,
          sunday: 7,
        };

        const targetDayNumber =
          weekdaysMap[weekDay.toLowerCase().replace("-string", "")];

        slotExercise.setProperty("protocolWeekDay", targetDayNumber);
      };

      const [weekPicker, setWeekPicker] = useState(false);
      const showWeekPicker = () => setWeekPicker(true);

      const PlanPicker = () => {
        const [isHovered, setIsHovered] = useState(false);

        const MenuItemView = ({ plan }) => {
          const [isHovered, setIsHovered] = useState(false);
          const [isDeleteHovered, setIsDeleteHovered] = useState(false);

          const handleSelectedPlan = (plan) => {
            plan.setProperty("weekDay", weekDay);
            setWeekPicker(false);
          };

          return (
            <MenuItem
              onPress={() => handleSelectedPlan(plan)}
              // style={{ minWidth: 100 }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  // backgroundColor: "red",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: isHovered ? "600" : "normal",
                  }}
                >
                  {plan.name}
                </Text>
              </View>
            </MenuItem>
          );
        };

        return (
          <View
            style={[
              GlobalStyles.HStack,
              {
                // marginVertical: screenSize === "large" ? 15 : 0,
              },
            ]}
          >
            <Menu
              visible={weekPicker}
              anchor={
                <TouchableOpacity
                  onPress={showWeekPicker}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    opacity: isHovered ? 0.5 : 1,
                  }}
                  onMouseEnter={() => !isMobile && setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <Octicons
                    name="plus"
                    size={24}
                    color={isOver ? "rgba(0, 255, 0, 0.5)" : Colors.borderColor}
                  />
                </TouchableOpacity>
              }
              style={[GlobalStyles.menu, { maxHeight: 500 }]} // Set a max height for the menu
              onRequestClose={() => setWeekPicker(false)}
            >
              <ScrollView>
                {client.nutritionPlans.map((nutritionPlan, idx) => (
                  <MenuItemView plan={nutritionPlan} key={idx} />
                ))}
              </ScrollView>
            </Menu>
          </View>
        );
      };

      return (
        <View
          ref={drop}
          style={{
            flex: 1,
            alignItems: "center",
            minWidth: 100,
          }}
        >
          <Header />
          {client.nutritionPlanInWeekday(weekDay) ? (
            <View
              style={{
                backgroundColor: isOver
                  ? "rgba(0, 255, 0, 0.1)"
                  : "transparent",
                alignItems: "center",
                borderRadius: 8,
                width: "100%",
                gap: 4,
                paddingVertical: 8,
              }}
            >
              <PlanButton
                plan={client.nutritionPlanInWeekday(weekDay)}
                isInWeekDay={true}
              />
            </View>
          ) : (
            <View
              style={{
                width: "calc(100% - 16px)",
                minHeight: 100,
                borderRadius: 8,
                borderWidth: 1,
                borderStyle: "dashed",
                // borderColor: Colors.borderColor,
                borderColor: isOver
                  ? "rgba(0, 255, 0, 0.5)"
                  : Colors.borderColor,
                alignItems: "center",
                justifyContent: "center",
                marginTop: 8,
                backgroundColor: isOver
                  ? "rgba(0, 255, 0, 0.1)"
                  : "transparent",
              }}
            >
              {/* <Octicons
                name="plus"
                size={24}
                color={isOver ? "rgba(0, 255, 0, 0.5)" : Colors.borderColor}
              /> */}
              <PlanPicker />
            </View>
          )}
        </View>
      );
    });

    return (
      <View
        style={{
          width: "100%",
          minWidth: 750,
          backgroundColor: "white",
          borderRadius: 14,
          paddingVertical: 16,
          paddingHorizontal: 8,
          alignItems: "center",
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          marginBottom: 16,
          alignSelf: "flex-start",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            width: "100%",
          }}
        >
          <WeekDay weekDay={"monday-string"} />
          <WeekDay weekDay={"tuesday-string"} />
          <WeekDay weekDay={"wednesday-string"} />
          <WeekDay weekDay={"thursday-string"} />
          <WeekDay weekDay={"friday-string"} />
          <WeekDay weekDay={"saturday-string"} />
          <WeekDay weekDay={"sunday-string"} />
        </View>
      </View>
    );
  };

  const NutritionPlanListView = observer(({ client }) => {
    return (
      <View style={{}}>
        {client &&
          client.nutritionPlans &&
          client.nutritionPlans
            .filter((np) => np.name.toLowerCase().includes(text.toLowerCase()))
            .map((nutritionPlan, idx) => (
              <PlanRow nutritionPlan={nutritionPlan} key={idx} />
            ))}
      </View>
    );
  });

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: Colors.backgroundColor,
        marginTop: screenSize === "small" ? 16 : 24,
        // justifyContent: "flex-start",
      }}
    >
      <View
        style={[GlobalStyles.HStack, { marginBottom: 16, maxWidth: "60%" }]}
      >
        <SearchBar
          text={text}
          onChangeText={(text) => setText(text)}
          placeholder={t("search-string")}
        />

        <CTAButton
          plus={true}
          text={t("newPlan-string")}
          action={() => {
            client.initAuxNutritionPlan();
            setShowingAddNutritionPlan(true);
          }}
          disabled={false}
        />
      </View>

      {/* {client && client.nutritionPlans && client.nutritionPlans.length > 1 && (
        <SplitView />
      )} */}

      <NutritionPlanListView client={client} />

      {showingAddNutritionPlan && client.auxNutritionPlan && (
        <AddNutritionPlanView
          isVisible={showingAddNutritionPlan}
          onClose={() => setShowingAddNutritionPlan(false)}
          nutritionPlan={client.auxNutritionPlan}
        />
      )}
    </View>
  );
};

export default ClientNutrition;
